import { MfaType } from '~/services/api/enums';

export const MFA_LABELS = {
  [MfaType.Email]: 'Email',
  [MfaType.Sms]: 'SMS',
};

export default {};
